__turbopack_context__.v({
  "adornment": "TextField-module-scss-module__sDahBq__adornment",
  "disabled": "TextField-module-scss-module__sDahBq__disabled",
  "error": "TextField-module-scss-module__sDahBq__error",
  "helper_text": "TextField-module-scss-module__sDahBq__helper_text",
  "input": "TextField-module-scss-module__sDahBq__input",
  "input_wrapper": "TextField-module-scss-module__sDahBq__input_wrapper",
  "label": "TextField-module-scss-module__sDahBq__label",
  "wrapper": "TextField-module-scss-module__sDahBq__wrapper",
});
